/* global google */
import { _breakP } from '../../common/js/lib/utils.js';

export default class LocationPage {
  constructor() {
    this.BUKKEN_ICON_SIZE_W = 90;
    this.BUKKEN_ICON_SIZE_H = 57;
    this.PLOT_ICON_SIZE_W = 33;
    this.PLOT_ICON_SIZE_H = 53;
    this.$lifeInfoDesc = document.getElementById('lifeInfoDesc');
    this.lifeInfoFunc();
  }

  lifeInfoFunc() {
    const $mapBlock = document.querySelectorAll('.js-mapBlock');
    const $sharedMapEl =
      this.$lifeInfoDesc?.querySelector('#map-shared') ?? null;

    if (!$mapBlock.length && !this.$lifeInfoDesc) return;

    const tag = document.createElement('script');
    tag.src =
      '//maps.google.com/maps/api/js?key=AIzaSyAjxgcyl2SMhGNnWy2tbGB_dDlwA-r9vHM&libraries=places&language=ja';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    const mapCreate = e => {
      const $dataLat = e.dataset.lat,
        $dataLng = e.dataset.lng,
        $mapId = e.getAttribute('id');

      const latlng = new google.maps.LatLng($dataLat, $dataLng);

      const $gMap = new google.maps.Map(document.getElementById($mapId), {
        zoom: _breakP.SP ? Number(e.dataset.spZoom) : Number(e.dataset.pcZoom),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
        streetViewControl: false,
        center: latlng,
        zoomControlOptions: {
          position: _breakP.SP
            ? google.maps.ControlPosition.LEFT_TOP
            : google.maps.ControlPosition.RIGHT_TOP
        },
        fullscreenControlOptions: {
          position: _breakP.SP
            ? google.maps.ControlPosition.TOP_LEFT
            : google.maps.ControlPosition.TOP_RIGHT
        }
      });

      const $mapStyle = [
        {
          featureType: 'all',
          elementType: 'all'
        }
      ];

      const $mapType = new google.maps.StyledMapType($mapStyle);
      $gMap.mapTypes.set('GrayScaleMap', $mapType);
      $gMap.setMapTypeId('GrayScaleMap');

      new google.maps.Marker({
        position: new google.maps.LatLng($dataLat, $dataLng),
        title: 'ルフォン蔵前グランスイート',
        map: $gMap,
        clickable: false,
        icon: {
          url: './imgs/plot/bukken.svg',
          scaledSize: new google.maps.Size(
            this.BUKKEN_ICON_SIZE_W,
            this.BUKKEN_ICON_SIZE_H
          ),
          anchor: new google.maps.Point(
            this.BUKKEN_ICON_SIZE_W / 2,
            this.BUKKEN_ICON_SIZE_H
          )
        }
      });

      return $gMap;
    };

    tag.onload = () => {
      if ($mapBlock.length) {
        $mapBlock.forEach(elm => {
          mapCreate.call(this, elm);
        });
      }

      if ($sharedMapEl) {
        this.initSharedMap($sharedMapEl, mapCreate);
      }
    };
  }

  initSharedMap(sharedEl, mapCreate) {
    const latlng = new google.maps.LatLng(
      sharedEl.dataset.lat,
      sharedEl.dataset.lng
    );
    const $gMap = mapCreate.call(this, sharedEl);

    const mapDataByGenre = new Map();
    let currentMarkers = [];
    let currentActiveGenre = null;

    const showMarkers = genre => {
      currentMarkers.forEach(({ marker, infoWindow }) => {
        marker.setMap(null);
        infoWindow.close();
      });
      currentMarkers = [];
      currentActiveGenre = genre;

      if (_breakP.SP) {
        // カテゴリ別に拡大率を上書きする場合: const overrides = { culture: 15, park: 15 }; const spZoom = overrides[genre] ?? ...;
        const spZoom = Number(sharedEl.dataset.spZoom);
        $gMap.setZoom(spZoom);
      }
      $gMap.setCenter(latlng);

      const list = mapDataByGenre.get(genre) || [];
      list.forEach((item, i) => {
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(item.lat, item.lng),
          title: item.name,
          map: $gMap,
          icon: {
            url: `./imgs/plot/icon-${String(i + 1).padStart(2, '0')}.svg`,
            scaledSize: new google.maps.Size(
              this.PLOT_ICON_SIZE_W,
              this.PLOT_ICON_SIZE_H
            ),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(
              this.PLOT_ICON_SIZE_W / 2,
              this.PLOT_ICON_SIZE_H
            )
          }
        });

        let ins = '<div class="map-window">';
        ins += `<p class="map-window_name">${item.name} ${item.minute}/${
          item.dist
            ? item.dist.replace(/(\d+)/g, match =>
                Number(match).toLocaleString()
              )
            : item.dist
        }</p>`;
        ins += '</div>';
        const infoWindow = new google.maps.InfoWindow({ content: ins });

        marker.addListener('click', () => {
          currentMarkers.forEach(e => e.infoWindow.close());
          infoWindow.open($gMap, marker);
        });

        currentMarkers.push({ marker, infoWindow });
      });
    };

    fetch('./data/mapData.json')
      .then(response => response.json())
      .then(dataArr => {
        dataArr.forEach(item => mapDataByGenre.set(item.genre, item.list));

        // 全タブのリストボタンにリスナを一括バインド
        this.$lifeInfoDesc
          .querySelectorAll('.lifeInfoDesc__table .js-tabCont')
          .forEach(tabCont => {
            const genre = tabCont.dataset.genre;
            tabCont.querySelectorAll('.js-lifeInfoBtn').forEach((btn, i) => {
              btn.addEventListener('click', () => {
                if (genre !== currentActiveGenre) return;
                const entry = currentMarkers[i];
                if (!entry) return;
                currentMarkers.forEach(e => e.infoWindow.close());
                $gMap.setCenter(entry.marker.getPosition());
                entry.infoWindow.open($gMap, entry.marker);
                if (_breakP.SP) {
                  const contentsTop =
                    window.pageYOffset + sharedEl.getBoundingClientRect().top;
                  window.scrollTo({ top: contentsTop, behavior: 'smooth' });
                }
              });
            });
          });

        // タブ切替時のマーカー差し替えフック
        const tabBtns = this.$lifeInfoDesc.querySelectorAll('.js-tabBtn');
        tabBtns.forEach((btn, idx) => {
          btn.addEventListener('click', () => {
            const genre = dataArr[idx]?.genre;
            if (genre) showMarkers(genre);
          });
        });

        // 初期マーカーを描画（activeIndex=0 に相当）
        const activeBtn = this.$lifeInfoDesc.querySelector(
          '.js-tabBtnWrap .js-tabBtn.is-active'
        );
        const activeBtnList = Array.from(
          this.$lifeInfoDesc.querySelectorAll('.js-tabBtn')
        );
        const activeIdx = activeBtn ? activeBtnList.indexOf(activeBtn) : 0;
        const initialGenre = dataArr[activeIdx]?.genre ?? dataArr[0]?.genre;
        if (initialGenre) showMarkers(initialGenre);
      })
      .catch(error => {
        console.error(error);
      });
  }
}
